<template>
  <div id="front-page">
    <div id="fp-center">

      <div id="fp-title-area">
        <h2>Ragnhild og Sebastian gifter seg!</h2>
        <h3>31.12.19</h3>
      </div>

      <fp-block left :img="imageArray[0]" >
        <h3>Vi skal gifte oss!</h3><br/>
        <p>Vi klarte ikke helt bestemme oss for hva vi skulle gjøre på nyttår, så i år feirer vi heller bryllup! Alltid greit å slå to fluer i en smekk.</p>
      </fp-block>

      <fp-block right :img="imageArray[1]" >
        <p><b>31. desember 2019</b> (ofte kalt nyttår) klokka <b>13:00</b> gifter vi oss i <a href="https://goo.gl/maps/nQijb2kx2JHFmiUF8" target="_blank" title="Vis i Google Maps"><b>Eiken Kyrkje</b></a> i Agder!</p><br>
        <p>Feiringen skal foregå på <a href="https://goo.gl/maps/WJy6krm5gpMRoQKy9" target="_blank" title="Vis i Google Maps"><b>Eikerapen Gjestegård</b></a>, ca. 30 minutter i bil fra kirken.</p><br/>
        <p class="small-p">På Eikerapen er det muligheter for å overnatte både natten før og etter bryllupet, 
          og det er et skitrekk hvor alle som overnatter får 10 % avslag på heiskort.</p>
      </fp-block>

      <fp-block left :img="imageArray[2]" >
        <h3>GAVER!</h3><br/>
        <p>
          Dersom dere vil kaste gaver i vår generelle retning, og ikke vil prøve deg på det ambisiøse prosjektet å gjette på hva vi ønsker oss, så har vi laget oss et par ønskelister! <br>
          Vi ønsker oss også penger til bryllupsreise og/eller livets opphold, så det tas imot med åpne armer!
        </p>
      </fp-block>

      <fp-block right :img="imageArray[3]" >
        <h3>Kontakt (kjedelig ord, driver vi butikk?)</h3><br>
        <p>
          Ragnhild er veldig glad i å prate i telefonen, så om du vil ringe for å spørre om noe, så kan hun nås på <b>469&nbsp;43&nbsp;096.</b> <br>
          Sebastian er mer glad i det skrevne ord, og kan nås på sms på <b>952&nbsp;87&nbsp;176</b>, eller via brevdue. Detaljer rundt brevdue-systemet arbeider vi fortsatt med. 
          <br> <br>
          
        </p>
      </fp-block>

      <fp-block left :img="toastmasterImage" >
        <h3>Toastmastere!</h3><br>
        <p>
          Som toastmastere får vi forresten god hjelp fra <b>Ruth-Elise Bergane</b> og <b>Janne Karine Hegelstad</b>, som Ragnhild bor med i Trondheim (fram til nyttår, selvfølgelig). <br>
          Dette er to jenter som er gira på at festen skal være full av program, men vil ikke stå for absolutt alt programmet helt selv, så om du vil bidra med noe gøyalt; ta kontakt med dem!
          <br>
          (REB: <b>476&nbsp;29&nbsp;447</b>, JKH: <b>909&nbsp;61&nbsp;174</b>)
        </p>
      </fp-block>

    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {

  },
  data () {
    return {
      imageArray: [
        {src: require('@/assets/festningen.jpg'),     text: 'Aketur på festningen slår aldri feil!'},
        {src: require('@/assets/hekkfjell-vol2.jpg'), text: 'Herlig dag ute i sola, 10/10 ville kommet tilbake hit.'},
        {src: require('@/assets/hettetroll.jpg'),     text: '“Hekkfjell, så kaldt på toppen her!”'},
        {src: require('@/assets/rutsjebane.jpg'),     text: '“Bremser er for pingler!” -Sebastian 2018'},
        {src: require('@/assets/haircut.jpg'),        text: '9mm var kortere enn vi trodde!'},
        {src: require('@/assets/car4.jpg'),           text: 'Bil + sol + musikk = God stemning'},
        {src: require('@/assets/nyforlova.png'),      text: '16. november gikk Sebastian ned på ett kne på båltur'},
        {src: require('@/assets/guitar.png'),         text: '"FEM PROSENT RABATT PÅ JOKER, GLADMANDAG BLIR DAGEN KALT!"'},
        {src: require('@/assets/flammer.jpg'),        text: 'Marshmallows, frukt og sjokolade - blir ikke bedre!'},
      ],
      toastmasterImage: {src: require('@/assets/toastmastere.jpg'),     text: 'Disse tullene skal holde styr på hele festen!'}
    }
  },
  computed: {

  },
  methods: {
    ...mapActions([ 'fetchWishLists', ]),
    randomizeImageArray() {
      for (let i = this.imageArray.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1))
        let temp = this.imageArray[i]
        this.imageArray[i] = this.imageArray[j]
        this.imageArray[j] = temp
      }
    }
  },
  created () {
    this.randomizeImageArray()
  },
  mounted() {
    this.fetchWishLists()
  }
}
</script>

<style lang="scss">
  #front-page {
    min-height: 100vh;
    width: 100%;

    background-position: center;
    background-image: url("../assets/mountains.jpg");
    background-size: cover;
    background-attachment: fixed;

    text-align: center;
    
    & > #fp-center {
      background-color: rgba(63, 63, 63, 0.76);
      width: 60vw;
      margin: auto;
      min-height: 100vh;
      @media screen and (max-width: 900px){
        width: 100%;
      }

      & > #fp-title-area {
        font-family: 'Courier New', Courier, monospace;
        color: white;
        
        & > h2 {
          font-size: calc(0.75em + 1.8vw);
          padding-top: 50px;
          padding-bottom: 10px;
          @media screen and (max-width: 900px){
            font-size: calc(1em + 2.8vw);
          }
        }

        & > h3 {
          font-size: calc(0.6em + 1.5vw);
          padding-bottom: 40px;
          @media screen and (max-width: 900px){
            font-size: calc(0.9em + 2vw);
          }
        }
      }
    }



  }
</style>
